/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import {
  Component,
  ElementRef,
  OnInit,
  Optional,
  ViewChild,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { PasswordValidator } from "../password-validator";
import { SignInService } from "../authServices/signin.service";
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { setActualDimensions } from "../../liveshop/utils/helpers";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  errorMessage: string;
  isErrorVerifyngOTP: boolean = false;
  user = { email: "", phone: "" };
  changePasswordForm = new FormGroup(
    {
      currentPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
      newPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
      confirmPassword: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
    },
    { validators: PasswordValidator }
  );
  public otpForm = this.formBuilder.group({
    box1: [null, [Validators.required, Validators.maxLength(1)]],
    box2: [null, [Validators.required, Validators.maxLength(1)]],
    box3: [null, [Validators.required, Validators.maxLength(1)]],
    box4: [null, [Validators.required, Validators.maxLength(1)]],
    box5: [null, [Validators.required, Validators.maxLength(1)]],
    box6: [null, [Validators.required, Validators.maxLength(1)]],
  });

  message;
  public username;
  currentPasswordType = "password";
  currentPasswordVisibility = false;
  newPasswordType = "password";
  newPasswordVisibility = false;
  confirmPasswordType = "password";
  confirmPasswordVisiblity = false;
  timeLeft = 30;
  interval;
  // timer = 0;
  isRegistrationOTPActive = false;

  @ViewChild("box1", { static: false }) box1: ElementRef;
  @ViewChild("box2", { static: false }) box2: ElementRef;
  @ViewChild("box3", { static: false }) box3: ElementRef;
  @ViewChild("box4", { static: false }) box4: ElementRef;
  @ViewChild("box5", { static: false }) box5: ElementRef;
  @ViewChild("box6", { static: false }) box6: ElementRef;
  windowHeight: number;
  windowWidth: number;

  constructor(
    private signInService: SignInService,
    @Optional()
    public dialogChangePassword: MatDialogRef<ChangePasswordComponent>,
    private tostrService: ToastrService,
    public formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.username = JSON.parse(localStorage.getItem("user")).username;
    this.signInService.changePasswordDataPass.subscribe(
      (data) => {
        if (data.email) {
          this.user.email = data.email;
        } else {
          this.user.phone = data.phone;
        }
        if (!Object.keys(data).length) {
          this.user.email = this.username;
        }
        if (this.isCustomer()) {
          this.sendOTP();
          this.isRegistrationOTPActive = false;
          if (!this.isRegistrationOTPActive) {
            this.startTimer();
          }
        }
      },
      (err) => console.log("Error while passing data from previous screen")
    );
    this.setDimensions();
  }
  get currentPassword() {
    return this.changePasswordForm.get("currentPassword");
  }
  get newPassword() {
    return this.changePasswordForm.get("newPassword");
  }
  get confirmPassword() {
    return this.changePasswordForm.get("confirmPassword");
  }

  sendOTP() {
    const request = {
      changePassword: false,
      forgotPassword: null,
      newPassword: null,
      otpGenerated: false,
      otpVerified: false,
      username: this.username,
      verifyPassword: null,
    };
    if (this.user.email) request["email"] = this.user.email;
    if (this.user.phone) request["phone"] = this.user.phone;
    if (sessionStorage.getItem("currentBusinessUnit")) {
      request["companyName"] = JSON.parse(
        sessionStorage.getItem("currentBusinessUnit")
      ).company?.name;
    }
    this.signInService.sendOTP(request).subscribe((res) => {
      setTimeout(() => {
        this.box1.nativeElement.focus();
      }, 1);
      this.isRegistrationOTPActive = false;
      if (!this.isRegistrationOTPActive) {
        this.startTimer();
      }
      // setTimeout(() => {
      //   this.isRegistrationOTPActive = true;
      // }, 30000);
      this.message = res["message"];
    });
  }

  getOtp() {
    if (this.otpForm.valid) {
      return (
        this.otpForm.controls.box1.value.toString() +
        this.otpForm.controls.box2.value.toString() +
        this.otpForm.controls.box3.value.toString() +
        this.otpForm.controls.box4.value.toString() +
        this.otpForm.controls.box5.value.toString() +
        this.otpForm.controls.box6.value.toString()
      );
    } else {
      this.tostrService.error("Invalid OTP", null, { timeOut: 2000 });
    }
  }

  passwordChange() {
    if (this.isCustomer()) {
      if (this.isCustomerFormValid()) {
        const request = {
          changePassword: false,
          forgotPasswordOtp: this.getOtp(),
          newPassword: this.newPassword.value,
          otpGenerated: true,
          otpVerified: false,
          username: this.username,
          verifyPassword: this.confirmPassword.value,
        };
        this.signInService.changePassword(request).subscribe(
          (res: any) => {
            if (res.status) {
              this.tostrService.success("Password changed successfully", null, {
                timeOut: 2000,
              });
              if (!this.isMobileDevice()) {
                this.dialogChangePassword.close();
              }

              // After password is updating,user will navigated to login page
            } else {
              this.tostrService.error("Something went wrong", null, {
                timeOut: 2000,
              });
            }
          },
          (err) => {
            this.tostrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        );
      }
    } else {
      const newpass = this.newPassword.value;
      const verifypass = this.confirmPassword.value;
      const currentpass = this.currentPassword.value;
      const request = {
        currentPassword: currentpass,
        newPassword: newpass,
        verifyPassword: verifypass,
      };
      if (!this.changePasswordForm.invalid) {
        this.signInService.updatePassword(request).subscribe(
          (res: any) => {
            if (res.status === true) {
              this.tostrService.success("Password changed successfully", null, {
                timeOut: 2000,
              });
              if (localStorage.getItem("retailerToken")) {
                localStorage.setItem("retailerToken", res.token.toString());
              } else {
                localStorage.setItem(
                  "nVipaniwhiteshopkey",
                  res.token.toString()
                );
              }
              if (!this.isMobileDevice()) {
                this.dialogChangePassword.close();
              }
            } else {
              this.isErrorVerifyngOTP = true;
              this.errorMessage =
                "Something Went Wrong while changing password. Please try again.";
              this.tostrService.error(this.errorMessage, null, {
                timeOut: 2000,
              });
            }
          },
          (err) => {
            this.isErrorVerifyngOTP = true;
            this.tostrService.error(err.error.message, null, {
              timeOut: 2000,
            });
          }
        );
      }
    }
  }

  isCustomerFormValid() {
    return (
      this.changePasswordForm.controls.newPassword.valid &&
      this.changePasswordForm.controls.confirmPassword.valid &&
      this.changePasswordForm.controls.newPassword.value ===
        this.changePasswordForm.controls.confirmPassword.value &&
      this.otpForm.valid
    );
  }

  isCustomer() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user.type === "B2C";
  }

  onKeyUpFunction(index) {
    const name = "box" + index;
    if (this.otpForm.controls[name].valid && index <= 6) {
      this.focus(index + 1);
    } else {
      this.otpForm.controls[name].reset();
    }
  }

  focus(index) {
    switch (index) {
      case 1:
        this.box1.nativeElement.focus();
        this.otpForm.controls.box1.reset();
        break;
      case 2:
        this.box1.nativeElement.blur();
        this.box2.nativeElement.focus();
        this.otpForm.controls.box2.reset();
        break;
      case 3:
        this.box2.nativeElement.blur();
        this.box3.nativeElement.focus();
        this.otpForm.controls.box3.reset();
        break;
      case 4:
        this.box3.nativeElement.blur();
        this.box4.nativeElement.focus();
        this.otpForm.controls.box4.reset();
        break;
      case 5:
        this.box4.nativeElement.blur();
        this.box5.nativeElement.focus();
        this.otpForm.controls.box5.reset();
        break;
      case 6:
        this.box5.nativeElement.blur();
        this.box6.nativeElement.focus();
        this.otpForm.controls.box6.reset();
        break;
      case 7:
        this.box6.nativeElement.blur();
      default:
        break;
    }
  }

  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const name = "box" + item;
      if (!this.otpForm.controls[name].valid) {
        this.focus(item);
        break;
      }
    }
    const name2 = "box" + index;
    this.otpForm.controls[name2].reset();
  }
  onPasteOtp($event: ClipboardEvent) {
    let pastedText = $event.clipboardData.getData("text");
    pastedText = pastedText.replace(/ /g, "");
    const otpRegex = new RegExp(/^[0-9]{6}$/);
    $event.preventDefault();
    $event.stopPropagation();
    if (pastedText.length !== 6 || !otpRegex.test(pastedText)) {
      this.tostrService.error("The OTP is not in correct format", null, {
        timeOut: 2000,
      });
      return;
    }
    for (let a = 0; a < 6; a++) {
      const name = "box" + (a + 1);
      this.otpForm.controls[name].reset();
      this.otpForm.controls[name].patchValue(pastedText[a]);
    }
    this.box1.nativeElement.blur();
    this.box2.nativeElement.blur();
    this.box3.nativeElement.blur();
    this.box4.nativeElement.blur();
    this.box5.nativeElement.blur();
    this.box6.nativeElement.blur();
  }

  closeDialog() {
    this.dialogChangePassword.close();
  }

  togglePasswordVisibility(type) {
    switch (type) {
      case "currentPassword":
        this.currentPasswordType =
          this.currentPasswordType === "password" ? "text" : "password";
        this.currentPasswordVisibility = !this.currentPasswordVisibility;
        break;
      case "newPassword":
        this.newPasswordType =
          this.newPasswordType === "password" ? "text" : "password";
        this.newPasswordVisibility = !this.newPasswordVisibility;
        break;
      case "confirmPassword":
        this.confirmPasswordType =
          this.confirmPasswordType === "password" ? "text" : "password";
        this.confirmPasswordVisiblity = !this.confirmPasswordVisiblity;
        break;
    }
  }
  startTimer() {
    clearInterval(this.interval);
    this.timeLeft = 30;
    this.isRegistrationOTPActive = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 1) {
        this.timeLeft = this.timeLeft - 1;
      } else {
        this.timeLeft = 30;
        this.isRegistrationOTPActive = false;
        //clearInterval(this.interval);
      }
    }, 1000);
  }
  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }
  isMobileDevice() {
    return this.windowWidth <= 6;
  }
  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 12;
  }
  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
